import { create } from "zustand";

export type ActiveCall = {
	session: any; // borogove_calls_Session
	isIncoming: boolean;
	chatId: string;
	accountId: string;
	hasVideo: boolean;
	screenSharing: boolean;
};

interface UIStore {
	sidebarOpen: boolean;
	activeThread: string | null;
	detailPanelOpen: boolean;
	activeCall: ActiveCall | null;
	setSidebarOpen: (open: boolean) => void;
	setActiveThread: (threadId: string | null) => void;
	setDetailPanelOpen: (open: boolean) => void;
	setActiveCall: (call: ActiveCall | null) => void;
}

export const useUIStore = create<UIStore>((set) => ({
	sidebarOpen: true,
	activeThread: null,
	detailPanelOpen: false,
	activeCall: null,
	setSidebarOpen: (open) => set({ sidebarOpen: open }),
	setActiveThread: (threadId) => set({ activeThread: threadId }),
	setDetailPanelOpen: (open) => set({ detailPanelOpen: open }),
	setActiveCall: (call) => set({ activeCall: call }),
}));
